<!-- MORE FILTERS PANEL-->
<p-overlayPanel (mouseleave)="hideOverlayPanel()" #op [style]="{ 'max-width': '80vw' }">
	<div class="container" class="custom-table" style="display: flex; flex-wrap: wrap; align-items: flex-end">
		<ng-container *ngFor="let extraFilter of extraFilters">
			<div class="extra-filter">
				<label
					id="extraFilterTitle"
					for="extraFilterTitle"
					class="form-label mb-0 me-3 custom-label logistics-label mt-2"
				>
					{{ extraFilter.header }}
				</label>

                <p-dropdown
                [options]="options[extraFilter.index]"
                [(ngModel)]="selectedValues[extraFilter.index]"
                [style]="{ 'min-width': '150px' }"
                (onFilter)="onFilter($event, extraFilter.index)"
                dataKey='id'
                [filter]="extraFilter.filter"
                [optionLabel]="extraFilter.filter"
                [filter]="true" 
                [filterBy]="extraFilter.filter"
            ></p-dropdown>
				
			</div>
		</ng-container>
		<p-button
			(click)="filterValues()"
			icon="pi pi-check"
			label="{{ 'general.filters.apply' | translate }}"
			class="mt-2 me-2"
		></p-button>
		<p-button
			(click)="removeFilters()"
			icon="pi pi-check"
			label="{{ 'general.filters.clear' | translate }}"
			class="mt-2"
		></p-button>
	</div>
</p-overlayPanel>
<div class="text-end">
	<p-button
		(click)="onOpen($event)"
		icon="text-white-500 pi pi-filter"
		label="{{ 'promotedRoutes.moreFilters' | translate }}"
		style="color: white !important"
		class="white-button-icon"
	>
	</p-button>
</div>
